var _path;
var _excluded = ["alt"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgBeachflagsRed = function SvgBeachflagsRed(_ref) {
  var alt = _ref.alt,
    props = _objectWithoutProperties(_ref, _excluded);
  var accessibilityProps = alt ? {
    'aria-label': alt,
    role: 'img'
  } : {};
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 100 100"
  }, accessibilityProps, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6223A",
    d: "M88.124 68.673c-25.415-7.47-50.83 7.469-76.245 0V31.327c25.415 7.47 50.83-7.469 76.245 0z"
  })));
};
export { SvgBeachflagsRed as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDEwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04OC4xMjQ0IDY4LjY3MjlDNjIuNzA5MyA2MS4yMDM4IDM3LjI5NDEgNzYuMTQyIDExLjg3ODkgNjguNjcyOVYzMS4zMjczQzM3LjI5NCAzOC43OTY0IDYyLjcwOTIgMjMuODU4MiA4OC4xMjQ0IDMxLjMyNzNWNjguNjcyOVoiIGZpbGw9IiNFNjIyM0EiLz4KPC9zdmc+Cg==";